import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  white-space: nowrap;\n  margin: 0;\n  padding: 0 2;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  color: on-background;\n  transition: base;\n  transition-property: color;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover,\n  &:focus {\n    color: on-background-light;\n  }\n\n  /* Reset button */\n  appearance: none;\n  border: 0;\n  background: transparent;\n  padding: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      overflow-x: auto;\n      max-width: calc(100vw - ", ") !important;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Link } from 'gatsby';
import styled, { x, th, down, css } from '@xstyled/styled-components';
export var Nav = styled.navBox(_templateObject(), down('md', css(_templateObject2(), th.px(72))));
var InnerNavLink = styled.aBox(_templateObject3());
export var NavLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InnerNavLink, Object.assign({
    ref: ref,
    as: Link
  }, props));
});
export var NavListItem = styled.liBox(_templateObject4());
export var NavList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(x.ul, Object.assign({
    ref: ref,
    m: 0,
    p: 0,
    row: true,
    alignItems: "center",
    flexWrap: "nowrap"
  }, props));
});